export const DELETE_GROUP_CONFIRMATION_MODAL_TEXT = {
	itemLabel: 'group',
	extraLabel: 'All group settings will be lost.',
	title: 'Are you sure you want to delete this group?',
};
